"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const recoil_1 = require("recoil");
const storyCreateStates_1 = require("./storyCreateStates");
const react_i18next_1 = require("react-i18next");
const api_1 = require("@/api");
const components_1 = require("@/common/components");
const styled_1 = __importDefault(require("@emotion/styled"));
function default_1() {
    const { t } = (0, react_i18next_1.useTranslation)();
    const [categories, setCategories] = (0, react_1.useState)([]);
    const [{ category_id }, setStoryData] = (0, recoil_1.useRecoilState)(storyCreateStates_1.storyDataState);
    (0, react_1.useEffect)(() => {
        (0, api_1.getData)('/api/v1/plays/stories/categories').then(res => {
            if (res.status === 200) {
                setCategories(res.data.result);
            }
        });
    }, []);
    return ((0, jsx_runtime_1.jsxs)(CategoryWrapper, { children: [(0, jsx_runtime_1.jsxs)("span", Object.assign({ id: "title" }, { children: [t('어떤 스토리인가요?'), (0, jsx_runtime_1.jsx)("span", Object.assign({ id: "asterisk" }, { children: "*" }))] })), (0, jsx_runtime_1.jsxs)(components_1.NativeSelect, Object.assign({ value: category_id, onChange: e => {
                    setStoryData(prev => (Object.assign(Object.assign({}, prev), { category_id: e.target.value })));
                }, sx: {
                    p: '10px 12px',
                    border: '1px solid rgba(0, 0, 0, 0.1) !important',
                    borderRadius: '4px',
                    mb: '6px',
                    fontSize: '16px',
                    '.MuiNativeSelect-icon': { right: '8px', width: '24px', height: '24px' },
                } }, { children: [(0, jsx_runtime_1.jsx)("option", Object.assign({ value: "" }, { children: t('선택해주세요') })), categories.map((categoryList) => {
                        const { id, name } = categoryList;
                        return ((0, jsx_runtime_1.jsx)("option", Object.assign({ value: id }, { children: name }), id));
                    })] }))] }));
}
exports.default = default_1;
const CategoryWrapper = styled_1.default.div `
  position: relative;
  flex-direction: column;
  padding: 16px;
  margin-bottom: 10px;
  background-color: white;
  cursor: pointer;
  #title {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    font-weight: 700;
    font-size: 17px;
  }
  #asterisk {
    margin-left: 2px;
    color: red;
    font-weight: normal;
  }
`;
